/**
 * PlayingContext — lightweight global flag indicating whether the site's
 * main audio player is currently playing.
 *
 * The Index page (which owns the playback engine) sets the value.
 * Any component on any page can read it to react to audio playback.
 */

import { createContext, useContext } from "react";

export const PlayingContext = createContext<boolean>(false);

export function usePlaying() {
  return useContext(PlayingContext);
}
